export default __webpack_public_path__ + "images/SpeakersPhotos/Javier_Peris.jpg?ccb12775";